'use client'

export default function GlobalError({ error }: { error: Error }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background text-foreground">
      <div className="text-center space-y-2">
        <p className="text-sm uppercase tracking-[0.3em] text-muted-foreground">Erreur</p>
        <h1 className="text-2xl font-semibold">Une erreur est survenue</h1>
        <p className="text-muted-foreground text-sm">{error?.message || 'Merci de réessayer plus tard.'}</p>
      </div>
    </div>
  )
}
